import React, { useEffect, useState } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { socialProofPurchases } from '../data/kit';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (isDismissed) return;
    const timer = setTimeout(() => setIsVisible(true), 5000);
    return () => clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const rotate = setInterval(() => {
      setIndex(i => (i + 1) % socialProofPurchases.length);
    }, 8000);
    return () => clearInterval(rotate);
  }, [isVisible, isDismissed]);
  const purchase = socialProofPurchases[index];
  return <AnimatePresence data-id="element-133" data-mp="3f28fb934xix7">
      {isVisible && !isDismissed && <motion.aside aria-label="Compra reciente" initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-6 left-4 right-4 sm:right-auto sm:left-6 z-50 bg-white rounded-2xl shadow-xl border border-brand-creamDark p-4 pr-10 sm:max-w-sm flex items-start gap-4" data-id="element-134" data-mp="3k364i5mkbd87">
          <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar aviso" className="absolute top-3 right-3 text-brand-gray transition-colors duration-150 ease-smooth hover:text-brand-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-greenDark rounded" data-id="element-135" data-mp="hezfry9dkqsh">
            <XIcon className="w-4 h-4" aria-hidden="true" data-id="element-136" data-mp="103nxycgh4i0k" />
          </button>

          <span className="w-10 h-10 rounded-full bg-brand-greenSoft flex items-center justify-center shrink-0" data-id="element-137" data-mp="1f1gbx06dgycn">
            <CheckIcon className="w-5 h-5 text-brand-greenDeep" aria-hidden="true" data-id="element-138" data-mp="1a2lh0zv4rjc6" />
          </span>

          <div aria-live="polite" data-id="element-139" data-mp="1h2nswklcqrqp">
            <p className="font-bold text-brand-text text-sm mb-0.5" data-id="element-140" data-mp="1m2to2aqtywdj">
              {purchase.name} &middot; {purchase.city}
            </p>
            <p className="text-brand-greenDeep font-bold text-xs mb-1" data-id="element-141" data-mp="1r1daec9c6a6f">
              Se llevó el Pack Pilates Listo
            </p>
            <p className="text-brand-gray text-[10px] flex items-center gap-1" data-id="element-142" data-mp="20srfr0nyy47h">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-check inline-block" data-id="element-143" data-mp="20uu2nbttrh7z" />
              Compra verificada &middot; hace {purchase.minutes} min
            </p>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}